<div class="pcs-container">
  <div class="pcs-header">
    <h3 class="pcs-title">Notifications</h3>
    <div class="card-actions">
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="countSelected == 0"
        [matBadge]="countSelected"
        [matBadgeSize]="'small'"
        [matBadgeColor]="'warn'"
        (click)="onMarkAsRead()"
      >
        Mark as read
      </button>
    </div>
  </div>
  <app-search-sort
    [searchControl]="searchControl"
    [sortForm]="sortForm"
    [sortOptions]="sortOptions"
    (apply)="setSortField()"
    (close)="resetSortField()"
  ></app-search-sort>
  <div class="pro-card column">

    <app-ag-grid-wrapper
      [data]="rowData"
      [columns]="columnDefs"
      [rowSelectionMode]="'multiple'"
      (ready)="onGridReady($event)"
      (selection)="onSelection($event)"
    />
    <mat-paginator
      #paginator
      [selectConfig]="{ panelClass: 'mat-paginator-select-options' }"
      [length]="totalCount"
      [pageIndex]="currentPage"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSettings.pageSizeOptions"
      (page)="handlePageEvent($event)"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</div>
